<div class="ps-xsmall-x ps-medium-b flex benefit-wrapper">
  @if (descriptionKey) {
    <span class="font-body-1 medium-type">{{ descriptionKey | finLocalization }}</span>
  }
  @if (tag) {
    <fcom-tag class="nowrap">
      @if (tag.icon) {
        <fcom-icon class="icon-small ms-xxsmall-r" [name]="tag.icon.name" [category]="tag.icon.category"></fcom-icon>
      }
      {{ tag.textKey | finLocalization }}
    </fcom-tag>
  }
</div>
